import { useMediaQuery } from 'react-responsive'

export const useIsBigScreen = () => useMediaQuery({ minDeviceWidth: 1024 } )
